var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.736,
    height: 74.736,
    viewBox: "0 0 74.736 74.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(-144 -306.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft",
    transform: "translate(144 306.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M272,35.033h35.033V2.336A2.336,2.336,0,0,0,304.7,0H272Z",
    transform: "translate(-232.296)",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M35.033,35.033V0H2.336A2.336,2.336,0,0,0,0,2.336v32.7Z",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M35.033,272H0v32.7a2.336,2.336,0,0,0,2.336,2.336h32.7Z",
    transform: "translate(0 -232.296)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M272,272v35.033h32.7a2.336,2.336,0,0,0,2.336-2.336V272Z",
    transform: "translate(-232.296 -232.296)",
    fill: "#ffc107"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsLogo);
export default __webpack_public_path__ + "static/media/windows-logo.770edb7657a20c1ba9d8b0497baf4e0a.svg";
export { ForwardRef as ReactComponent };